module.exports = __webpack_public_path__ + "static/media/res7.70af366d.PNG";